import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChartsService } from "../../charts/charts-services/charts.service";
import { ChartsFieldsGroup } from "../../charts/charts.model";
import { ContextService } from "../../context/state/context.service";

@Component({
  selector: "app-verbatim-structured-fields",
  templateUrl: "./verbatim-structured-fields.component.html",
  styleUrls: ["./verbatim-structured-fields.component.scss"],
  standalone: false,
})
export class VerbatimStructuredFieldsComponent implements OnInit, OnDestroy {
  @Input() structuredData: any;
  @Input() fieldGroups: ChartsFieldsGroup[];
  STRUCTURED_GROUP = "Structured Fields";
  destroyed$ = new Subject<boolean>();

  constructor(
    private contextService: ContextService,
    public chartsService: ChartsService,
  ) {}

  ngOnInit() {
    if (!this.fieldGroups) {
      this.contextService.allContext$
        .pipe(takeUntil(this.destroyed$))
        .subscribe((context) => {
          this.chartsService
            .getChartsFields(context?.ds?.uuid, context?.ds?.source_type)
            .subscribe(
              (chartsFieldsData: ChartsFieldsGroup[]) =>
                (this.fieldGroups = chartsFieldsData),
            );
        });
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
